"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _constants = require("../constants");

var _default = _propTypes["default"].oneOf([_constants.OPEN_DOWN, _constants.OPEN_UP]);

exports["default"] = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@jsluna/date-picker/~/react-dates/lib/shapes/OpenDirectionShape.js
// module id = 63
// module chunks = 0